/**
 * Product Form Components
 *
 */
class ProductForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    this.cartElement = document.querySelector('ajax-cart');

    this.qtyBtns = this.querySelectorAll('[data-qty-btn]');
    this.qtyBtns.forEach(qtyBtn => qtyBtn.addEventListener('click', this.manageQtyBtn.bind(this)));
  }

  /**
   * Product Form Submit event
   *
   * @param {evt} Event instance
   */
  onSubmitHandler(evt) {
    evt.preventDefault();
    var addItems = [];
    const addOnItems = [];
    var isMultipleItems = false;
    const submitButton = this.querySelector('[type="submit"]');
    const qtyInput = this.querySelector('[data-qty-input]');
    const pdpContainer = this.closest('.product-details-wrapper');

    submitButton.setAttribute('disabled', true);
    submitButton.querySelector('.add-text').innerHTML = "Adding...";

    if (submitButton.classList.contains('addSavedItems')) {
      var totalItem = JSON.parse(localStorage.getItem('saved_item'))
      totalItem.map((i) => {
        const {id, qty} = i;
        addItems = [...addItems, {id: id, quantity: qty}];
      })
      isMultipleItems = true;
    } else {
      addItems.push(JSON.parse(serializeForm(this.form)))
      if(pdpContainer){
        let addOnItemsEle = pdpContainer.querySelectorAll('[data-addon-selection]:checked');
        addOnItemsEle.forEach((addOn)=>{
          if(addOn.disabled == false){
            let addOnParent = addOn.closest('addons-form');
            let addOnJSON = {
              id: addOnParent.querySelector('.variant--id').value,
              quantity: addOnParent.querySelector('.product-quantity').value
            }
            addItems.push(addOnJSON);
          }
        });
      }
    }

    const body = JSON.stringify({
      items: addItems
    });
    
    fetch(`${routes.cart_add_url}`, { ...fetchConfig(), body })
      .then((response) => response.json())
      .then((parsedState) => {
        if (parsedState.errors != undefined) {
          if (parsedState.errors == "Cart Error") {
            window.notificationEle.updateNotification('Cart Error', 'Products are already added to the cart.', {
              type: 'success',
              timeout: 10000
            });
          }
        } else {
          if (!isMultipleItems) {
            this.addToCartModalPopup(submitButton);
          } else {
            window.location.href = "/cart";
          }
        }
        if(qtyInput) qtyInput.value = 1;
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        submitButton.removeAttribute('disabled');
        submitButton.querySelector('.add-text').innerHTML = "ADD TO CART";
      });
  }

  addToCartModalPopup(submitButton = null, onlyItemCount = true) {
    fetch(`${routes.cart_fetch_url}?view=custom`, {headers: {'Content-Type': 'application/text'}}).then(response => {
      return response.text();
    }).then(response => {
      const newCart = new DOMParser().parseFromString(response, 'text/html');
      response = JSON.parse(newCart.querySelector('[data-new-cart-json]').innerHTML);
      
      var itemCount = 0;
      var cartTotalPrice = 0;
      if (response.items.length > 0) {
        response.items.forEach(cartItem => {
          if(cartItem.product_type != "PPLR_HIDDEN_PRODUCT") {
            itemCount += cartItem.quantity;
          }
        let customerPricingGroupCategory = window.globalVariables.kpcust_pricing_group||`null`;
        let customerType=window.globalVariables.kpcustomer_type||`Retail`;
        if (customerPricingGroupCategory===`null`&&customerType===`Wholesale`) {
            customerPricingGroupCategory=`Wholesale`
        }
        if (customerPricingGroupCategory!==`null`) {
            var priceData = VariantSelects.prototype.checkProductPrice(JSON.parse(newCart.querySelector(`.variantsJSON-${cartItem.id}`).innerHTML));
            if (priceData.length == 3) {
              cartTotalPrice += (cartItem.id == 43358169661678) ? (parseFloat((priceData[0]).replace('$', '')) * cartItem.quantity) : (parseFloat((priceData[0]).replace('$', '')) * cartItem.quantity * 100);
            } else {
              cartTotalPrice = response.original_total_price;
            }
          } else {
            cartTotalPrice = response.original_total_price;
          }
        });
      }
      if(itemCount == 0) {
        itemCount = "";
      }
      if (onlyItemCount) {
        //document.querySelector('#PopupModal-addToCart .modal #itemAdded').innerHTML = `${response.items[0].title} <span id="cartPopupSku">${response.items[0].sku}</span>`
       // document.querySelector('#PopupModal-addToCart .modal #cartTotal').innerHTML = `${itemCount} Item(s) | Subtotal: ${Shopify.formatMoney(cartTotalPrice, window.globalVariables.money_format).replaceAll(' USD', '')}`
       // document.querySelector('#PopupModal-addToCart .modal').classList.add('open'); 
       // siteOverlay.prototype.showOverlay(); 
      }
      if (submitButton != undefined) {
        submitButton.querySelector('.add-text').innerHTML = submitButton.getAttribute('aria-label');
      }
      var cartUpdateData = document.querySelectorAll('.cart-link-wrapper');
      if (cartUpdateData.length > 0) {
        cartUpdateData.forEach(el => {
          el.querySelector('.items').innerHTML = `Items in Your Cart: <span class='pplr_cart_count'>${itemCount}</span>`;
          el.querySelector('.items').classList.remove('d-none')
          el.querySelector('.items').classList.add('d-block');
          el.querySelector('.cart_count').innerHTML = `Current Total: ${Shopify.formatMoney(cartTotalPrice, window.globalVariables.money_format).replaceAll(' USD', '')}`;
          el.querySelector('.cart_count').classList.remove('d-none')
          el.querySelector('.cart_count').classList.add('d-block');
          // el.querySelector('.cart-checkout-link').classList.remove('d-none')
          // el.querySelector('.cart-checkout-link').classList.add('d-block');
          (el.querySelector('.no-item-cart') != null) && el.querySelector('.no-item-cart').classList.add('d-none');
        });
      }
      var cartTotal = Shopify.formatMoney(cartTotalPrice, window.globalVariables.money_format).replaceAll(' USD', '');
      (document.querySelector('[data-carttotal] .money') != null) ? (document.querySelector('[data-carttotal] .money').innerHTML = cartTotal) : '';
      (document.querySelector('[data-subcarttotal] .money') != null) ? (document.querySelector('[data-subcarttotal] .money').innerHTML = cartTotal) : '';
      (document.querySelector('[data-cartprice]') != null) ? document.querySelector('[data-cartprice]').setAttribute('data-cartprice', cartTotalPrice) : '';
      document.querySelectorAll('.pplr_cart_count').forEach(item => {
        item.innerHTML = itemCount;
      })
      document.querySelectorAll('.cart-popup .header__icon--cart').forEach(item => {
        (item.querySelector('.cart-count') != null) ? (item.querySelector('.cart-count').innerHTML = `<span class='pplr_cart_count'>${itemCount}</span>`) : item.insertAdjacentHTML('afterBegin', `<span aria-hidden="true" class="cart-count"><span class='pplr_cart_count'>${itemCount}</span></span>`)
      })
    })
  }

  /**
   * Product Form Quantity Input update action
   *
   * @param {event} Event instance
   */
  manageQtyBtn(event) {
    event.preventDefault();
    let currentTarget = event.currentTarget;
    let action = currentTarget.dataset.for || 'increase';
    let $qtyInput = currentTarget.closest('[data-qty-container]').querySelector('[data-qty-input]');
    let currentQty = parseInt($qtyInput.value) || 1;
    let finalQty = 1;

    if(action == 'decrease' && currentQty <= 1){
        return false;
    }else if(action == 'decrease'){
        finalQty = currentQty - 1;
    }else if(currentQty === parseInt($qtyInput.getAttribute('max'))){
      return false;
    }else if(currentQty < parseInt($qtyInput.getAttribute('max'))){
        finalQty = currentQty + 1;
    }

    $qtyInput.value = finalQty;
  }
}
customElements.define('product-form', ProductForm);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.form = this.closest('form') || this.closest('.form-element');
    this.formType = this.form.dataset.format;
    this.addBtn = this.form.querySelector('[name="add"]');
    this.variant_json = this.form.querySelector('[data-variantJSON]');
    this.variantPicker = this.dataset.type;

    if(this.formType == 'product-page') this.onVariantChange('load');
    this.addEventListener('change', this.onVariantChange.bind(this));
  }

  onVariantChange(event) {
    this.setCurrentVariant();
    if(this.formType == 'product-page') window.globalVariables.product.currentVariant = this.currentVariant;

    if (!this.currentVariant) {
      this.toggleAddButton('disable');
    } else {
      if(this.formType == 'grid'){
        const productGrid = this.closest('[data-product-grid]');
        this.renderProductInfo(this.currentVariant, productGrid, event);
        this._updateLinks(productGrid); 
        const productWrap = this.closest('.product-form');
        Shopify.optionsMap = {};
        this.defaultProductOptionSetup(productWrap);
        this.checkOptionSelection(productWrap);
      }else{
        if(event){
          const productWrap = this.closest('.product-form');
          if(event == 'load'){
            templateProductJS.prototype.manageVariantSlider(this.currentVariant);
          }else if(event){
            let currentTarget = event.target;
            let pdpContainer = currentTarget.closest('[data-product-container]');
            let quickShopModal = currentTarget.closest('#PopupModal-quickshop');
            let targetName = currentTarget.getAttribute('name') || '';
            targetName = targetName.toLowerCase();

            if(pdpContainer && (targetName.indexOf('color') > -1 || targetName.indexOf('options[color]') > -1)){
              if(quickShopModal){
                quickShop.prototype.manageVariantSlider(this.currentVariant);
              }else{
                templateProductJS.prototype.manageVariantSlider(this.currentVariant);
              }
            }
          }
          Shopify.optionsMap = {};
          this.defaultProductOptionSetup(productWrap);
          this.checkOptionSelection(productWrap);
        }

        const productPage = this.closest('[data-product-container]');
        this.renderProductInfo(this.currentVariant, productPage, event);
        this.updateQty(this.currentVariant);
        window.currentVariantId = this.currentVariant.id;
        window.currentVariantTitle = this.currentVariant.public_title;
      }
      this.updateURLandID(this.currentVariant);
      this.toggleAddButton('enable');
    }
  }

  // setup product option global data.
  defaultProductOptionSetup(productData) {
    Shopify.arrayIncludes = function(e, t) {
      for (var n = 0; n < e.length; n++)
        if (e[n] == t)
          return !0;
      return !1
    };
  
    Shopify.uniq = function(e) {
      for (var t = [], n = 0; n < e.length; n++)
        Shopify.arrayIncludes(t, e[n]) || t.push(e[n]);
      return t
    };

    var productId = `productVariants_${window.productJson.id}`;
    var productVariants = window[productId];
    var productOptions = JSON.parse(productData.getAttribute('data-product-options'));
    for (var i = 0; i < productVariants.length; i++) {
      var variant = productVariants[i];

      if (variant.available) {
        // Gathering values for the 1st drop-down.
        if (productOptions.length === 1) {
          Shopify.optionsMap['root'] = Shopify.optionsMap['root'] || [];
          Shopify.optionsMap['root'].push(variant.option1);
          Shopify.optionsMap['root'] = Shopify.uniq(Shopify.optionsMap['root']);
        } 
        
        // Gathering values for the 2nd drop-down.
        if (productOptions.length > 1) {
          var key = variant.option1;
          Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];
          Shopify.optionsMap[key].push(variant.option2);
          Shopify.optionsMap[key] = Shopify.uniq(Shopify.optionsMap[key]);
        } 
        
        // Gathering values for the 3rd drop-down.
        if (productOptions.length === 3) {
          var key = variant.option1 + ' / ' + variant.option2;
          Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];
          Shopify.optionsMap[key].push(variant.option3);
          Shopify.optionsMap[key] = Shopify.uniq(Shopify.optionsMap[key]);
        }
      }
    }
  }

  // add disable class to input label
  addDisableClassToOptionLable(productData) {
    var optionData = productData.querySelectorAll('[data-format] .js.product-form__input');
    if(optionData.length > 0) {
      optionData.forEach((el, i) => {
        var optionElement = el.querySelectorAll('.list-unstyled li');
        if(optionElement.length > 0) {
          optionElement.forEach((item, i) => {
            item.querySelector('label').classList.add('is--disable');
          })
        }
      })
    }
  }

  checkOptionSelection(productData) {
    this.addDisableClassToOptionLable(productData);
    var optionsCount = productData.querySelectorAll('[data-format] .js.product-form__input').length;
    if(optionsCount > 0 && Shopify.optionsMap["root"] !== undefined) {
      if (optionsCount === 1) {
        Shopify.optionsMap["root"].forEach((el, i) => {
          productData.querySelector(`[data-format] .js.product-form__input .list-unstyled label[title="${el}"]`).classList.remove('is--disable');
        })
      } else if (optionsCount === 2) {
        var option_1 = productData.querySelector('[data-format] .js.product-form__input:first-child .list-unstyled input:checked').value;
        var option_2 = productData.querySelector('[data-format] .js.product-form__input:last-child .list-unstyled input:checked').value;

        if(Shopify.optionsMap[option_1] != undefined) {
          Shopify.optionsMap[option_1].forEach((el, i) => {
            productData.querySelector(`[data-format] .js.product-form__input .list-unstyled label[title="${el}"]`).classList.remove('is--disable');
          })
        }

        for(var key in Shopify.optionsMap) {
          if(Shopify.optionsMap[key].indexOf(option_2) != -1) {
            productData.querySelector(`[data-format] .js.product-form__input .list-unstyled label[title="${key}"]`).classList.remove('is--disable');
          }
        }
      } else if (optionsCount === 3) {
        var option_1 = productData.querySelector('[data-format] .js.product-form__input:first-child .list-unstyled input:checked').value;
        var option_2 = productData.querySelector('[data-format] .js.product-form__input:nth-child(2) .list-unstyled input:checked').value;
        var option_3 = productData.querySelector('[data-format] .js.product-form__input:last-child .list-unstyled input:checked').value;

        if(Shopify.optionsMap[option_1] != undefined) {
          Shopify.optionsMap[option_1].forEach((el, i) => {
            var option2 = Shopify.optionsMap[option_1][i];
            productData.querySelector(`[data-format] .js.product-form__input .list-unstyled label[title="${option2}"]`).classList.remove('is--disable');
          })
        }

        var option2Data = `${option_1} / ${option_2}`;
        Shopify.optionsMap[option2Data].forEach((el, i) => {
          var option3 = Shopify.optionsMap[option2Data][i];
          productData.querySelector(`[data-format] .js.product-form__input .list-unstyled label[title="${option3}"]`).classList.remove('is--disable');
        })

        var customOption1 = [];
        var firstSwatchOptions = productData.querySelectorAll('[data-format] .js.product-form__input:first-child .list-unstyled li');
        if(firstSwatchOptions.length > 0) {
          firstSwatchOptions.forEach((optionEl, i) => {
            customOption1.push(optionEl.querySelector('label').getAttribute('title'));
          })
        }
        customOption1.forEach((el, i) => {
          var customOptionName = `${el} / ${option_2}`;
          if (Shopify.optionsMap[customOptionName] != undefined && Shopify.optionsMap[customOptionName].indexOf(option_3) != -1) {
            productData.querySelector(`[data-format] .js.product-form__input .list-unstyled label[title="${el}"]`).classList.remove('is--disable');
          } else {
            productData.querySelector(`[data-format] .js.product-form__input .list-unstyled label[title="${el}"]`).classList.add('is--disable');
          }
        })

        var customOption2 = [];
        var firstSwatchOptions = productData.querySelectorAll('[data-format] .js.product-form__input:nth-child(2) .list-unstyled li');
        if(firstSwatchOptions.length > 0) {
          firstSwatchOptions.forEach((optionEl, i) => {
            customOption2.push(optionEl.querySelector('label').getAttribute('title'));
          })
        }
        customOption2.forEach((el, i) => {
          var customOption2Name = `${option_1} / ${el}`;
          if (Shopify.optionsMap[customOption2Name] != undefined && Shopify.optionsMap[customOption2Name].indexOf(option_3) != -1) {
            productData.querySelector(`[data-format] .js.product-form__input .list-unstyled label[title="${el}"]`).classList.remove('is--disable');
          } else {
            productData.querySelector(`[data-format] .js.product-form__input .list-unstyled label[title="${el}"]`).classList.add('is--disable');
          }
        })
      }
    }
  }

  updateQty(currentVariant) {
    var currentVariantId = currentVariant.id;
    var varJson = JSON.parse(document.querySelector('[data-variant-inventory]').textContent);
    var varQty = parseInt(varJson[currentVariantId]);
    var html = "";
    for (let index = 1; index <= varQty; index++) {
      html += `<option value="${index}">${index}</option>`;
    }
    document.querySelector('#quantity').innerHTML = html;
  }

  _updateLinks(productGrid){
    if(!this.currentVariant || !productGrid) return;
    const variantURL = '?variant=' + this.currentVariant.id;
    const formLinks = productGrid.querySelectorAll('.product-link');
    formLinks.forEach(link => {
      let href = link.href.split('?')[0];
      link.href = href + variantURL;
    });
  }

  _getOptionsFromSelect() {
    let options = [];
    this.querySelectorAll('.variant_selector').forEach((selector)=>{
      options.push(selector.value);
    });
    return options;
  }

  _getOptionsFromRadio() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset:not(.addon-fieldset)'));
    const options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input:not(.addon-swatch)')).find((radio) => radio.checked).value;
    });
    return options;
  }

  setCurrentVariant() {
    // get all current values from selectors
    this.currentVariant = false;
    let options = (this.variantPicker == 'variant-select') ? this._getOptionsFromSelect() : this._getOptionsFromRadio();

    let variantsArray = this._getVariantData();
    variantsArray.find((variant) => {
      // get true or false based on options value presented in variant
      // value format would be [true/false,true/fasle,true/false] boolean value based on options present or not
      let mappedValues = variant.options.map((option, index) => {
        return options[index] === option;
      });

      // assign variant details to this.currentVariant if all options are present
      if(!mappedValues.includes(false)){
        this.currentVariant = variant;
        return;
      }
    });
  }

  updateURLandID(currentVariant) {
    if (!currentVariant) return;

    // update query string with latest variant ID
    if(this.formType == 'product-page') window.history.replaceState({ }, '', `${this.dataset.url}?variant=${currentVariant.id}`);

    // update variant input with currentVariant Id
    const input = this.form.querySelector('input[name="id"]');
    input.value = currentVariant.id;
  }

  checkProductPrice(currentVariant) {
    const kpprice_percentage_of=window.globalVariables.kpprice_percentage_of;
    const kpprice_percentage = window.globalVariables.kpprice_percentage;
    const kpcustomer_type=window.globalVariables.kpcustomer_type;
    let use_price=currentVariant.price;
    switch (true) {
      case kpprice_percentage_of==="Wholesale"||kpcustomer_type==="Wholesale":
        use_price=currentVariant.compare_at_price/2;
        break;
      case kpprice_percentage_of==="Retail"&&kpprice_percentage>0:
        use_price=currentVariant.compare_at_price;
        break;
    }

    const discount_amount=use_price*kpprice_percentage;
    let new_price=use_price-discount_amount;
    if (new_price>currentVariant.price) { // sometimes, the sale price is less than the special pricing. In that case, let's just use the lesser price
      new_price=currentVariant.price;
    }
    var productPersonalizationFactor = (currentVariant.id == 43358169661678) ? 100 : 1;
    if (kpprice_percentage>0||kpcustomer_type===`Wholesale`) {
      if (kpprice_percentage_of===`Retail`) {
        var compare_price = Shopify.formatMoney(currentVariant.price, window.globalVariables.money_format).replaceAll(' USD', '');
        var price = (new_price) * productPersonalizationFactor;
      } else {
        var price = (currentVariant.compare_at_price > currentVariant.price) ? currentVariant.compare_at_price : currentVariant.price; 
        var compare_price = Shopify.formatMoney(price, window.globalVariables.money_format).replaceAll(' USD', ''); 
        price = (new_price) * productPersonalizationFactor;       
      }
      price=Shopify.formatMoney(price, window.globalVariables.money_format).replaceAll(' USD', '');
      return [price, compare_price, 'discounted_price'];
    } else {
      var price = Shopify.formatMoney(currentVariant.price, window.globalVariables.money_format).replaceAll(' USD', '');
      var compare_price = Shopify.formatMoney(currentVariant.compare_at_price, window.globalVariables.money_format).replaceAll(' USD', '');
      return [price, compare_price];
    }
  }

  renderProductInfo(currentVariant, container, event) {
    if(!currentVariant || !container) return;
    let customerPricingGroupCategory = window.globalVariables.kpcust_pricing_group||`null`;
    let customerType=window.globalVariables.kpcustomer_type||`Retail`;
    if (customerPricingGroupCategory===`null`&&customerType===`Wholesale`) {
        customerPricingGroupCategory=`Wholesale`
    }
    if (customerPricingGroupCategory!==`null`) {
      const specialPricingText=window.hideWholesale?"(No wholesale pricing available)":"";
      var priceData = this.checkProductPrice(currentVariant);
      if (priceData[2] == "discounted_price"&&!window.hideWholesale) {
        document.querySelector('.special-compare-price').innerHTML =  customerPricingGroupCategory + ': ' + priceData[0];
      } else {
        document.querySelector('.special-compare-price').innerHTML =  specialPricingText;
      }
      var price = Shopify.formatMoney(currentVariant.price, window.globalVariables.money_format).replaceAll(' USD', '');
      var compare_price = Shopify.formatMoney(currentVariant.compare_at_price, window.globalVariables.money_format).replaceAll(' USD', '');
    } else {
      var price = Shopify.formatMoney(currentVariant.price, window.globalVariables.money_format).replaceAll(' USD', '');
      var compare_price = Shopify.formatMoney(currentVariant.compare_at_price, window.globalVariables.money_format).replaceAll(' USD', '');
    }
    let priceElement = container.querySelector('[data-currentPrice]');
    let comparePriceElement = container.querySelector('[data-comparePrice]');
    
    // if(event != 'load'){
      if(priceElement) priceElement.innerHTML = price;
      if(comparePriceElement) {
        comparePriceElement.innerHTML = compare_price;
        if(currentVariant.compare_at_price <= 0){
          comparePriceElement.style.display = 'none';
        }else{
          comparePriceElement.style.display = 'inline-block';
        }
      }
    // }
    
    // Grid Image Update on variant selection
    if(this.formType == 'grid'){
      if(!currentVariant.featured_image) return;
      const featuredImage = container.querySelector('[data-feauredImage]');
      let updatedSrc = currentVariant.featured_image.src;
      if(updatedSrc){
        featuredImage.src = updatedSrc;
        featuredImage.srcset = updatedSrc;
      }
    }else{
      if(!currentVariant.featured_image) return;
      let imageID = currentVariant.featured_media.id;
      let imageSlide = document.querySelector(`.product--media[data-mediaID="${imageID}"]`);
      if(this.formType == 'quickshop'){
        imageSlide = document.querySelector(`.quickshop-slider .product--media[data-mediaID="${imageID}"]`);
      }
      if(!imageSlide) return;
      let slideIndex = Array.from(imageSlide.parentNode.children).indexOf(imageSlide);
      if(quickShopSlider) quickShopSlider.slideTo(slideIndex, 2000, true);
      else if(productSlider)  productSlider.slideTo(slideIndex, 2000, true);
    }
  }

  toggleAddButton(status) {
    if (!this.addBtn) return;

    if (status == 'disable') {
      this.addBtn.setAttribute('disabled', true);
      if(this.addBtn.querySelector('.add-text'))
        this.addBtn.querySelector('.add-text').textContent = window.variantStrings.unavailable;
    } else if(this.currentVariant && !this.currentVariant.available) {
      this.addBtn.setAttribute('disabled', true);
      if(this.addBtn.querySelector('.add-text'))
        this.addBtn.querySelector('.add-text').textContent = window.variantStrings.soldOut;
    } else {
      this.addBtn.removeAttribute('disabled');
      if(this.form.classList.contains('cart-upsell-form')){
        this.addBtn.querySelector('.add-text').textContent = window.variantStrings.upsellAddText;
      }else{
        this.addBtn.querySelector('.add-text').textContent = window.variantStrings.addToCart;
      }
    };
  }

  _getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.variant_json.textContent);
    return this.variantData;
  }
}
  
customElements.define('variant-selects', VariantSelects);
  
class VariantRadios extends VariantSelects {
  constructor() {
    super();

    this.form = this.closest('form') || this.querySelector('.form-element');
    this.formType = this.form.dataset.format;
    
    const colorSwatchContainer = this.querySelector('.color-swatch');
    if(colorSwatchContainer){
      const colorSwatches = colorSwatchContainer.querySelectorAll('.swatch');
      colorSwatches.forEach(swatch => {
        let colorHandle = swatch.querySelector('input[type="radio"]').dataset.handle;
        let swatchStyle = Utility.getSwatchStyle(colorHandle);
        swatch.querySelector('.swatch-label').setAttribute('style', swatchStyle);
      });
    }
  }
}
customElements.define('variant-radios', VariantRadios);

class CustomAddToCart {
  constructor() {
    this.init();
  }

  addToCartFunctionDesk() {
    window.setupAddToCartFunctionDesk = function() {
      const that = this;
      var addToCartBtns = document.querySelectorAll('.add--to--cart:not(.is-initialized)');
      if (addToCartBtns.length > 0) {
        addToCartBtns.forEach(addToCart => {
          addToCart.addEventListener('click', function(e) {
            e.stopPropagation();
            e.stopImmediatePropagation();
            addToCart.classList.add('is-initialized');
            var variantId = addToCart.closest('.grid-addtocart-wrapper').querySelector('.product-card-size-varinat.selected-var').getAttribute('data-var-id');
            if (variantId != null) {
              addToCart.classList.add('disabled');
              addToCart.innerHTML = "Adding...";
              const bodyObj={};
              bodyObj.id=variantId;
              bodyObj.quantity=1;
              let productProperties={};
              let productInputProperties=e.target.closest(`.swatch-data-details.grid-addtocart-wrapper`).querySelectorAll(`input[type="hidden"][name^="properties"]`);
              for (const input of productInputProperties){
                  productProperties[input.name.replace(`properties[`,``).replace(`]`,``)]=input.value;
              }
              productProperties[`_kp_adddate`]=`true`;
              bodyObj.properties=productProperties;
              const body=JSON.stringify(bodyObj);
              fetch(`${routes.cart_add_url}`, { ...fetchConfig(), body })
              .then((response) => response.json())
              .then((parsedState) => {
                if (parsedState.errors != undefined) {
                  if (parsedState.errors == "Cart Error") {
                    window.notificationEle.updateNotification('Cart Error', 'Products are already added to the cart.', {
                      type: 'success',
                      timeout: 10000
                    });
                  }
                } else {
                  ProductForm.prototype.addToCartModalPopup();
                  $(`.cart-link`)[0].click();
                }
              })
              .catch((e) => {
                console.error(e);
              })
              .finally(() => {
                addToCart.classList.remove('disabled');
                addToCart.innerHTML = "ADD TO CART";
              });
            } else {
              window.notificationEle.updateNotification('Add To Cart Error', 'Please select a size to add to cart.', {
                type: 'success',
                timeout: 10000
              });
            }
          })
        })
      }
    }
    window.setupAddToCartFunctionDesk();
  }

  init() {
    this.addToCartFunctionDesk(); 
  }
}

new CustomAddToCart;